import React, { useState, useEffect } from "react";
import "./SliderBanner.css"; // Import your CSS file
import { Link } from "react-router-dom";

const SliderBanner = () => {
  const slides = [
    {
      id: 1,
      image: "Images/Home_Banner_1.webp",
      title: "Transforming Agriculture with Technology",
      subtitle:
        "Empowering Farmers with Innovative Solutions for a Sustainable Future",
    },
    {
      id: 2,
      image: "Images/Home_Banner_2.webp",
      title: "We Make Farming Better Smarter Efficient ",
      subtitle:
        "Empowering Farmers with Innovative Solutions for a Sustainable Future",
    },
    {
      id: 3,
      image: "Images/Home_Banner_3.webp",
      title: "Smarter Farming for a Sustainable Future ",
      subtitle:
        "Empowering Farmers with Innovative Solutions for a Sustainable Future",
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = slides.length;

  // Auto-slide every 5 seconds
  useEffect(() => {
    const autoSlide = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(autoSlide); // Cleanup on component unmount
  }, [currentSlide]);

  const nextSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="slider-container">
      <div className="slider">
        {slides.map((slide, index) => (
          <div
            className={index === currentSlide ? "slide current" : "slide"}
            key={slide.id}
          >
            <div className="slide-content">
              <img
                src={slide.image}
                alt={slide.title}
                className="slide-image"
              />
              <div className="banner-container">
                <h1 className="banner-title">{slide.title}</h1>
                <p className="banner-subtitle">{slide.subtitle}</p>
                <div className="button-group">
                  <Link to="/contact">
                    <button className="banner-button connect-button">
                      Connect with Us
                    </button>
                  </Link>{" "}
                  <Link to="/pricing">
                    <button className="banner-button get-started-button">
                      Get Started
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Navigation Arrows */}
        <div className="left-arrow" onClick={prevSlide}>
          &#10094;
        </div>
        <div className="right-arrow" onClick={nextSlide}>
          &#10095;
        </div>

        {/* Dots for slide navigation */}
        <div className="dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={index === currentSlide ? "dot active" : "dot"}
              onClick={() => goToSlide(index)}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SliderBanner;
